<template>
  <div id="v-nodata">

      <v-layout>
          <v-container>


              <v-card>
                <v-card-text >
                    <center>

                        <v-icon :size="80" color="red">error</v-icon>
                        <h4 >You are not authorized to see this page</h4>
                        <v-btn  @click="home">Go Home</v-btn>
                    </center>
                </v-card-text>
                </v-card>

          </v-container>

      </v-layout>


  </div>
</template>


<script>
export default {
  name: 'v-nodata',
  props: {
    title: {
      type: String,
    },
    msgDetails: {
      type: String,
    },
    enableHeader: {
      type: Boolean,
      default: false,
    },
    networkError: {
      type: Boolean,
      default: false,
    },
    contentBg: {
      type: String,
      default: 'white',
    },
    loading: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
    },
  },

  data() {
    return {

    };
  },
  computed: {

  },
  methods: {
    home() {
      window.location.href = '/';
    },
  },
};
</script>
